export default __webpack_public_path__ + "static/media/magistratura_haqida_nizom.e712c88e.pdf";